import React, {useState} from 'react'
import {Button, Input} from 'react-daisyui'
import LoadingSpinner, {LoadingSpinnerSize} from '../common/LoadingSpinner'
import clsx from 'clsx'
import {useForm} from 'react-hook-form'
import {usePostOTAReservationMutation} from '../../services/guestPortalApi'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import AddOTAReservationForm from './AddOTAReservationForm'

export const AddOTAReservation = ({
  onSignUpSuccess
}: {
  onSignUpSuccess?: Function
}) => {
  const {
    register,
    handleSubmit,
    formState: {errors},
    watch
  } = useForm()

  const [
    postOTAReservation,
    postOTAReservationResult
  ] = usePostOTAReservationMutation()

  const handleSignUp = (data: any) => {
    // event.preventDefault()

    // try {
    postOTAReservation(data)
      .unwrap()
      .then(payload => {
        console.log('fulfilled', payload)

        if (onSignUpSuccess) {
          setTimeout(() => {
            onSignUpSuccess(payload)
          }, 1000)
        }
      })
      .catch(error => console.error('rejected', error))
  }

  return (
    <div>
      <div className="font-semibold text-lg text-center">
        Let's look up your third party reservation.
      </div>
      {postOTAReservationResult.isLoading ? (
        <div className="flex flex-row justify-center items-center pt-4 gap-2">
          <LoadingSpinner size={LoadingSpinnerSize.Large} />
        </div>
      ) : (
        ''
      )}
      {postOTAReservationResult.isError ? (
        <div>
          <div className="text-red-500 flex flex-row justify-center items-center pt-4 text-lg">
            {'data' in postOTAReservationResult.error
              ? (postOTAReservationResult.error.data as {message?: string})
                  ?.message
              : 'Unable to locate your reservation. Please try again.'}
          </div>
          <Button
            color="secondary"
            className="w-full mt-8 text-white"
            onClick={() => postOTAReservationResult.reset()}
          >
            Try again
          </Button>
        </div>
      ) : (
        ''
      )}
      {postOTAReservationResult.isSuccess ? (
        <div className="flex flex-row justify-center items-center pt-4 gap-2">
          <FontAwesomeIcon className="text-2xl" icon={faCheckCircle} />
          {/* {JSON.stringify(postOTAReservationResult.data)} */}
          <div className="text-xl">Success!</div>
        </div>
      ) : (
        ''
      )}

      {postOTAReservationResult.isUninitialized && (
        <AddOTAReservationForm onFormSubmit={handleSignUp} />
      )}
    </div>
  )
}

export default AddOTAReservation
